/**
 * Protect Delivery Surcharge Line Item
 * Prevents customers from modifying or removing the delivery surcharge
 */

(function() {
  'use strict';
  
  // Function to protect surcharge items
  function protectSurchargeItems() {
    // Find all cart items with delivery surcharge
    const surchargeItems = document.querySelectorAll(
      '[data-product-handle="delivery-time-slot"], ' +
      '[data-line-item-property="_surcharge_item"], ' +
      '.cart-item:has([data-line-item-property="_surcharge_item"])'
    );
    
    surchargeItems.forEach(item => {
      // Disable quantity inputs
      const quantityInputs = item.querySelectorAll('input[type="number"], input.quantity');
      quantityInputs.forEach(input => {
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('disabled', 'disabled');
        input.style.pointerEvents = 'none';
        input.style.opacity = '0.5';
      });
      
      // Hide or disable remove buttons
      const removeButtons = item.querySelectorAll(
        '.cart-item__remove, .cart__remove, .remove-item, ' +
        'a[href*="/cart/change"], button[data-action="remove"]'
      );
      removeButtons.forEach(button => {
        button.style.display = 'none';
        button.setAttribute('disabled', 'disabled');
      });
      
      // Hide quantity controls
      const quantityControls = item.querySelectorAll(
        '.cart-item__quantity, .cart__quantity, .quantity-selector, ' +
        '.js-qty__adjust, .quantity__button'
      );
      quantityControls.forEach(control => {
        control.style.display = 'none';
      });
      
      // Add protected class
      item.classList.add('delivery-surcharge-protected');
    });
  }
  
  // DISABLED: Intercept cart API calls to prevent surcharge removal
  // This was causing rate limiting issues (429 errors) by making too many /cart.js requests
  // The removal protection is now handled by the custom removal flow in cart-delivery-picker.liquid

  /* DISABLED CODE:
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url, options] = args;

    // Convert URL to string if it's a Request or URL object
    const urlString = typeof url === 'string' ? url : url.toString();

    // Check if this is a cart update
    if (urlString && (urlString.includes('/cart/update') || urlString.includes('/cart/change'))) {
      if (options && options.body) {
        try {
          let body = options.body;
          
          // Parse the body if it's a string
          if (typeof body === 'string') {
            body = JSON.parse(body);
          }
          
          // Check for updates that would remove surcharge items
          if (body.updates) {
            // Get current cart to check which items are surcharge items
            return originalFetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                // Find surcharge items in cart
                const surchargeKeys = cart.items
                  .filter(item => 
                    item.product_handle === 'delivery-time-slot' ||
                    (item.properties && item.properties['_surcharge_item'] === 'true')
                  )
                  .map(item => item.key);
                
                // Prevent removal of surcharge items
                surchargeKeys.forEach(key => {
                  if (body.updates[key] === 0) {
                    console.warn('Preventing removal of delivery surcharge');
                    delete body.updates[key];
                  }
                });
                
                // Continue with modified request
                options.body = JSON.stringify(body);
                return originalFetch.apply(this, [url, options]);
              });
          }
        } catch (e) {
          console.error('Error protecting surcharge:', e);
        }
      }
    }
    
    // Pass through other requests unchanged
    return originalFetch.apply(this, args);
  };
  END OF DISABLED CODE */

  // Run protection on page load
  document.addEventListener('DOMContentLoaded', protectSurchargeItems);
  
  // Run protection after cart updates
  document.addEventListener('cart:updated', protectSurchargeItems);
  document.addEventListener('ajaxCart:updated', protectSurchargeItems);
  
  // Monitor for dynamic cart changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        protectSurchargeItems();
      }
    });
  });
  
  // Start observing cart container for changes
  const cartContainer = document.querySelector('.cart, #cart, .cart-drawer, #CartDrawer');
  if (cartContainer) {
    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }
  
  // Add CSS to ensure styling is applied
  const style = document.createElement('style');
  style.textContent = `
    .delivery-surcharge-protected {
      background: #fef9e7 !important;
      border: 1px solid #f2c206 !important;
      border-radius: 8px !important;
      padding: 15px !important;
      margin-bottom: 10px !important;
    }
    
    .delivery-surcharge-protected .cart-item__quantity,
    .delivery-surcharge-protected .cart__quantity,
    .delivery-surcharge-protected .quantity-selector {
      display: none !important;
    }
    
    .delivery-surcharge-protected .cart-item__remove,
    .delivery-surcharge-protected .cart__remove,
    .delivery-surcharge-protected .remove-item {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
  
})();